export const ErrorPage = () => {
	return (
		<div>
			<p>
				Opps, you took a wrong turn. Go back <a href='/'>home</a>
			</p>
		</div>
	);
};
